<div class="col-lg-12 col-md-5 col-sm-0 col-xs-12 p0 flumainsecHt"></div>
<mat-tab-group>
  <mat-tab label="Recent Payments">
    <ng-template matTabContent>
      <app-latest-payment></app-latest-payment>
    </ng-template>
  </mat-tab>
  <mat-tab label="Historical Payments">
    <ng-template matTabContent>
      <app-old-payment></app-old-payment>
    </ng-template>
  </mat-tab>
</mat-tab-group>
